import { ServerPricing, TimesPrice } from '../types';

export const adapterTimePricing = (res: ServerPricing) => {
  let latestPrice = -1;
  const timesPrice: TimesPrice = [];
  Object.entries(res).forEach(([key, value]) => {
    const numKey = Number(key);
    if (value !== latestPrice) {
      timesPrice.push({
        startTime: numKey,
        endTime: numKey + 1,
        price: value,
      });
      latestPrice = value;
    } else {
      timesPrice[timesPrice.length - 1].endTime = numKey + 1;
    }
  });
  return (timesPrice);
};
